import { CloudDownloadOutlined, DeleteOutlined, EditOutlined, FileExcelOutlined, FilePdfOutlined, ShopOutlined, TeamOutlined } from '@ant-design/icons'
import { Button, Card, Checkbox, Col, DatePicker, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Table, Tag, Tooltip } from 'antd'
import TextArea from 'antd/lib/input/TextArea';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../store/hooks/easyPeasy'
import { SelectMonth } from '../../select/SelectMonth';
import { SelectYear } from '../../select/SelectYear';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactExport from "react-export-excel";

const ExcelFile: any = ReactExport.ExcelFile;
const ExcelSheet: any = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn: any = ReactExport.ExcelFile.ExcelColumn;

const { Option } = Select;


export default function IspBillListPIP(props) {

    const check = useStoreState(state => state.isp.check);
    const ispClientBillInfoListForPip = useStoreState(state => state.isp.ispClientBillInfoListForPip);
    const fetchispClientBillInfoListForPip = useStoreActions(state => state.isp.fetchispClientBillInfoListForPip);
    const downloadVoucher = useStoreActions(state => state.isp.downloadVoucher);

    const [form] = Form.useForm();
    const [formUpdate] = Form.useForm();

    const columns1 = [

        {
            title: 'Client Id',
            dataIndex: 'clientCustomId',
            key: 'clientCustomId',


        },
        {
            title: 'Client Name',
            dataIndex: 'clientName',
            key: 'clientName',

        },
        {
            title: 'Mobile No',
            dataIndex: 'clientMobile',
            key: 'clientMobile',


        },
        {
            title: 'Address',
            dataIndex: 'mailingAddress',
            key: 'mailingAddress',

        },
        {
            title: 'Package Name',
            dataIndex: 'packageName',
            key: 'packageName',

        },
        {
            title: 'Package Price',
            dataIndex: 'billAmount',
            key: 'billAmount',

        },
        {
            title: 'Payment Date',
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    {record?.billPaymentDate === "null" ? 'N/A' : record?.billPaymentDate}

                </Space>
            ),
        },
        {
            title: 'Download Report',
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    <Button icon={<CloudDownloadOutlined />}
                        type="primary"
                        onClick={() => {
                            let postData = {
                                billId: record.billId
                            }
                            downloadVoucher(postData)
                        }}
                    >
                        Download</Button>
                </Space>
            ),
        }



    ]
    const columns2 = [

        {
            title: 'Client Id',
            dataIndex: 'clientCustomId',
            key: 'clientCustomId',


        },
        {
            title: 'Client Name',
            dataIndex: 'clientName',
            key: 'clientName',


        },
        {
            title: 'Mobile No',
            dataIndex: 'clientMobile',
            key: 'clientMobile',


        },
        {
            title: 'Address',
            dataIndex: 'mailingAddress',
            key: 'mailingAddress',

        },
        {
            title: 'Package Name',
            dataIndex: 'packageName',
            key: 'packageName',

        },
        {
            title: 'Package Price',
            dataIndex: 'billAmount',
            key: 'billAmount',

        },

        {
            title: 'Payable Date',
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    {record?.billPayableDate === "null" ? 'N/A' : record?.billPayableDate}

                </Space>
            ),
        },
        {
            title: 'Download Report',
            render: (text: any, record: any, index) => (
                <Space size="middle">
                    <Button icon={<CloudDownloadOutlined />}
                        type="primary"
                        onClick={() => {
                            let postData = {
                                billId: record?.billId,
                            }
                            downloadVoucher(postData)
                        }}
                    >
                        Download</Button>
                </Space>
            ),
        }


    ]
    const [colData, setcolData] = useState<any>([])
    const [colDataPdf, setcolDataPdf] = useState<boolean>(false)

    const onFinish = (values: any) => {

        if (values.billStatus == 1) {
            setcolData(columns1)
            setcolDataPdf(true)
        }

        if (values.billStatus == 0) {
            setcolData(columns2)
            setcolDataPdf(false)
        }

        setfilterTable(null);
        setsearchv('')
        fetchispClientBillInfoListForPip(values)
    };

    function downloadPdf() {

        const doc = new jsPDF("landscape");
        var totalPagesExp = '{total_pages_count_string}';
        const tableRows: any[][] = [];
        var width = doc.internal.pageSize.getWidth()
        doc.text('Sheba Technologies Limited (STL)', width / 2, 20, { align: 'center' })
        doc.setFontSize(10)
        doc.text(`${colDataPdf ? "Paid" : "Unpaid"} Bill Report for the Month of ${month},${year}`, width / 2, 30, { align: 'center' })
        // doc.setFontSize(10)
        let totalBill = 0
        ispClientBillInfoListForPip.forEach((item: any) => {
            const itemData = [
                item.clientCustomId,
                item.clientName,
                item.clientMobile,
                item.mailingAddress,
                item.packageName,
                item.billAmount,
                colDataPdf ? item.billPaymentDate : item.billPayableDate,


            ];
            totalBill += item.billAmount
            tableRows.push(itemData);
        });


        // @ts-ignore


        doc.autoTable(colDataPdf ? ["Client Id", "Client Name", "Mobile No", "Address", "Package Name", "Payment Price", "Payment Date"] : ["Client Id", "Client Name", "Mobile No", "Address", "Package Name", "Payment Price", "Payable Date"], tableRows, {
            startY: 35,
            pageBreak: "auto",
            rowPageBreak: "auto",
            theme: "plain",
            didDrawPage: function (data) {
                doc.setFontSize(10);

                // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                var pageSize = doc.internal.pageSize;
                var pageHeight = pageSize.height
                    ? pageSize.height
                    : pageSize.getHeight();
                doc.setTextColor(150)
                doc.setFontSize(10)
                doc.text('Powered by Sheba Digital Limited | Part of Sheba Group.', width / 2 - 40, pageHeight - 10);
            }

        });
        let finalY = (doc as any).lastAutoTable.finalY;
        doc.setFontSize(11);
        doc.text(`Total Bill Amount: ${totalBill} `, width - 70, finalY + 10)


        doc.save(`Bill.pdf`);
    }


    useEffect(() => {
        setPageTitle();
    }, []);




    const setPageTitle = () => {
        var pageTitleEle = document.getElementById('pageTitle');
        var pageTitle = 'ISP'
        return pageTitleEle ? pageTitleEle.innerHTML = pageTitle : ''
    }

    const [filterTable, setfilterTable] = useState<any>(null);
    const [searchv, setsearchv] = useState<any>('');
    const search = value => {

        const result = ispClientBillInfoListForPip.filter(o =>
            Object.keys(o).some(k =>
                String(o[k])
                    .toLowerCase()
                    .includes(value.toLowerCase())
            )
        );
        setfilterTable(result)

    };

    const [month, setMonth] = useState<any>(null);
    const [year, setYear] = useState<any>(null);


    return (
        <>
            <Form layout="vertical" onFinish={onFinish} id='create-class' form={form} >
                <Row gutter={15} className="box-shadow p-15">
                    <Col xs={24} sm={24} md={24} lg={3} xl={3}></Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>

                        <Form.Item
                            name="billStatus"
                            label="Bill Status:"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select bill status" },
                            ]}
                        >
                            <Select placeholder="Select Bill Status" style={{ width: "100%" }} allowClear>
                                <Option value="1">Paid</Option>
                                <Option value="0">Unpaid</Option>
                                <Option value="2">Disabled</Option>
                            </Select>


                        </Form.Item>

                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>

                        <Form.Item
                            name="billMonth"
                            label="Month:"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select month" },
                            ]}
                        >
                            <SelectMonth onChange={(val) => setMonth(val)} selected={month} />


                        </Form.Item>

                    </Col>
                    <Col xs={24} sm={24} md={24} lg={5} xl={5}>

                        <Form.Item
                            name="billYear"
                            label="Year:"
                            className="title-Text"
                            rules={[
                                { required: true, message: "Please select year" },
                            ]}
                        >
                            <SelectYear onChange={(val) => setYear(val)} selected={year} />


                        </Form.Item>

                    </Col>

                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>

                        <Space size="small" style={{ marginTop: 30 }} >
                            <Button type="primary" htmlType="submit" >
                                Search
                            </Button>
                        </Space>

                    </Col>

                </Row>
            </Form>
            {ispClientBillInfoListForPip?.length > 0 &&
                <Card title="Bill List" >
                    <span>Total Found: {ispClientBillInfoListForPip !== null ? ispClientBillInfoListForPip?.length : 0}</span>
                    <Input
                        style={{ margin: "0 0 10px 0", width: 250, float: "right" }}
                        placeholder="Search..."
                        value={searchv}
                        allowClear
                        onChange={(e) => { search(e.target.value); setsearchv(e.target.value) }}
                    />
                    <Table
                        bordered={true}
                        dataSource={searchv === '' ? ispClientBillInfoListForPip : filterTable}
                        columns={colData}
                        rowKey="clientCustomId"
                        // pagination={false}
                        summary={pageData => {
                            let totalBill = 0;

                            ispClientBillInfoListForPip.forEach(({ billAmount }) => {
                                totalBill += billAmount;
                            });

                            return (
                                <>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                                        <Table.Summary.Cell index={1}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={2}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={3}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={4}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={5}>
                                            <Text type="danger" strong>{totalBill}</Text>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={6}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={7}>

                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell index={8}>

                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>

                                </>
                            );
                        }}
                    />
                    <Space style={{ float: 'right' }} size="middle">
                        <ExcelFile element={<Button type="primary" icon={<FileExcelOutlined />} > Download Excel </Button>}>
                            <ExcelSheet data={ispClientBillInfoListForPip} name="Bill">
                                <ExcelColumn label="Client Id" value="clientCustomId" />
                                <ExcelColumn label="Client Name" value="clientName" />
                                <ExcelColumn label="Mobile No" value="clientMobile" />
                                <ExcelColumn label="Address" value="mailingAddress" />
                                <ExcelColumn label="Package Name" value="packageName" />
                                <ExcelColumn label="Package Price" value="billAmount" />
                                {colDataPdf ? <ExcelColumn label="Payment Date" value="billPaymentDate" /> : <ExcelColumn label="Payable Date" value="billPayableDate" />}
                            </ExcelSheet>
                        </ExcelFile>
                        <Button type="primary" icon={<FilePdfOutlined />} onClick={downloadPdf} > Download PDF </Button>
                    </Space>
                </Card>

            }

        </>
    )
}
